import * as types from "../actions/actionTypes";

const initialState = {
  file: null,
  positionX: 0,
  positionY: 0,
  canvasReady: true,
  orientation: "left"
};

const pdfReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_PDF_FILE: {
      return {
        ...state,
        canvasReady: false,
        file: action.file,
        positionX: action.positionX,
        positionY: action.positionY,
        orientation: action.orientation
      };
    }
    case types.HIDE_PDF_FILE:
      return { ...state, file:null, positionX: 0, positionY: 0 };
    case types.SET_CANVAS_READY_PDF_FILE:
      return { ...state, canvasReady: true };
    default:
      return state;
  }
};

export default pdfReducer;


// WEBPACK FOOTER //
// ./src/reducers/pdfReducer.js